module.exports = __webpack_public_path__ + "img/2d12cc4.svg";